<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)">
        <template v-if="hasName()">
          {{name}}
        </template>
        <template v-else>
          {{ showName(item) }}
        </template>
      </span>
      <router-link :to="item" v-else>{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>

<script>

import EventBus from '@/event-bus.js'
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      name: '',
      lastpath: ''
    }
  },
  created () {
    EventBus.$on('breadcrumnaming', information => {
      this.lastpath = this.$route.fullPath
      this.name = information
    })
  },
  methods: {
    hasName () {
      return (this.name && this.lastpath === this.$route.fullPath)
    },
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue